import {
  getErrorMessage,
  hasConcreteRequestContext,
  isRecoverableNetworkError,
} from "../utils/networkErrors";

const collectMessages = (event, hint) => {
  const originalException = hint?.originalException;
  return [
    event?.message,
    getErrorMessage(originalException),
    originalException?.stack,
    ...(event?.exception?.values || []).flatMap((exception) => [
      exception?.type,
      exception?.value,
      exception?.stacktrace?.frames
        ?.map((frame) => [frame?.filename, frame?.module, frame?.function].filter(Boolean).join(" "))
        .filter(Boolean)
        .join(" "),
    ]),
  ]
    .filter(Boolean)
    .join("\n");
};

export const shouldDropKnownNoiseEvent = (event, hint) => {
  const text = collectMessages(event, hint);

  if (
    text.includes("navigationPerformanceLoggerWithReply") &&
    text.includes("window.webkit.messageHandlers")
  ) {
    return true;
  }

  if (/ResizeObserver loop limit exceeded/i.test(text)) {
    return true;
  }

  if (/gtag\/js/i.test(text) && /can't access property "stop"|access property stop/i.test(text)) {
    return true;
  }

  if (/Branch SDK initialization failed/i.test(text)) {
    return true;
  }

  if (/\.data\.split is not a function/i.test(text)) {
    return true;
  }

  if (/ENOSPC|No space left on device/i.test(text)) {
    return true;
  }

  if (
    isRecoverableNetworkError(hint?.originalException || event?.message) &&
    !hasConcreteRequestContext(event)
  ) {
    return true;
  }

  return false;
};
